export default __webpack_public_path__ + "static/micromotor-a49bda83762d210ac13b5182aa516164.png";